export enum ChipSelection {
  UNTIL_LAST_MONTH = 'untilLastMonth',
  THIS_MONTH = 'thisMonth',
  LAST_MONTH = 'lastMonth',
  NEXT_MONTH = 'nextMonth',
  UNTIL_LAST_WEEK = 'untilLastWeek',
  THIS_WEEK = 'thisWeek',
  LAST_WEEK = 'lastWeek',
  NEXT_WEEK = 'nextWeek',
  CUSTOM = 'custom'
}

export enum YearChipSelection {
  LAST_YEAR = 'lastYear',
  THIS_YEAR = 'thisYear',
  NEXT_YEAR = 'nextYear'
}

export type SelectedChip = (typeof ChipSelection)[keyof typeof ChipSelection];
export type SelectedYearChip =
  (typeof YearChipSelection)[keyof typeof YearChipSelection];
